import { CLAYTON_WORKSPACE_ID } from '@/config/ui'

import { User, Workspace, WorkspaceUser } from '@/types/index.d'

export enum WorkspaceAlerts {
  TRUE_UP = 'TRUE_UP',
  UPCOMING_RENEWAL = 'UPCOMING_RENEWAL',
  OVERDUE_INVOICE_2 = 'OVERDUE_INVOICE_2',
  GRACE_PERIOD = 'GRACE_PERIOD',
  OVERDUE_INVOICE_1 = 'OVERDUE_INVOICE_1',
  NO_ALERT = 'NO_ALERT',
}

export const WORKSPACE_DOMAIN_VALIDATION =
  /^((?!www.)[a-z0-9])+([\\-\\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/

export function isWorkspaceAdmin(user: User, workspaceId: string): boolean {
  return (
    user?.roles.find((role) => role.workspace_id === workspaceId)?.role ===
    'ADMIN'
  )
}

export function isWorkspaceUserAdmin(user: WorkspaceUser): boolean {
  return user.role === 'ADMIN'
}

export function isClaytonWorkspaceAdmin(
  user: User,
  currentWorkspace: Workspace
): boolean {
  const currentRole = user.roles.filter(
    (role) => role.workspace_id == currentWorkspace.id
  )[0]

  return (
    currentRole.role === 'ADMIN' &&
    currentRole.workspace_id === CLAYTON_WORKSPACE_ID
  )
}
